<template>
  <select
    class="donate-card__input_half donate-card__input_half_r"
    required
    @change="$emit('input', $event.target.value)"
  >
    <option
      value=""
      disabled
      selected
    >Select Country *</option>
    <option
      class="select-dash"
      disabled="disabled"
    >----</option>
    <option
      v-for="country in sortedCountries"
      :key="country.key"
      :value="country.key">
      {{ country.value }}
    </option>
  </select>
</template>
<script>
export default {
  name: 'DonateCardStepTwoSelectCountry',

  props: {
    countries: {
      type: [Array, Object],
      required: true
    }
  },

  computed: {
    sortedCountries() {
      return Object.keys(this.countries)
        .map(key => ({ key, value: this.countries[key] }))
        .sort((a, b) => {
          if (a.value < b.value) {
            return -1
          }
          if (a.value > b.value) {
            return 1
          }
          return 0
        })
    }
  }
}
</script>
